import React from "react";
import * as S from './button-component.style';
import { ButtonProps } from "./button-component.types";

const Button: React.FC<ButtonProps> = ({ children, primary, disabled, size = "medium", onClick }) => {
  return (
    <S.StyledButton
      $primary={primary}
      disabled={disabled}
      $size={size}
      onClick={onClick}
    >
      {children}
    </S.StyledButton>
  );
};

export default Button;